import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

/* Public Pages */
import Home from "./public/pages/Home";
import About from "./public/pages/About";
import Tournaments from "./public/pages/Tournaments";
import Contact from "./public/pages/Contact";
import Donate from "./public/pages/Donate";
import UnderConstruction from "./public/pages/UnderConstruction";
import ApplicationLogsPublicPage from "./public/pages/ApplicationLogsPublicPage";

/* Auth */
import AdminLogin from "./public/pages/AdminLogin";
import UserLogin from "./public/pages/UserLogin";
import DonorLogin from "./public/pages/DonorLogin";
import StudentLogin from "./public/pages/StudentLogin";
import SessionTimeout from "./public/pages/SessionTimeout";
import PaymentStatusPage from "./features/payment/PaymentStatusPage";

import AppShellLayout from "./app/layouts/AppShellLayout";
import AppScreenAccessGuard from "./app/guards/AppScreenAccessGuard";
import { APP_SCREEN_ROUTES } from "./app/routes/screenRegistry";
import { VISITOR_LEGACY_ROUTES } from "./features/visitor/utils/visitorRoutes";
import { RoleShellRoutes } from "./app/shells/RoleShellRoutes";
import { DynamicRoleShellRoutes } from "./app/shells/DynamicRoleShellRoutes";
import "./app/styles/appScreenGuard.css";
import DocumentHead from "./app/DocumentHead";

function App() {
  return (
    <Router>
      <DocumentHead />
      <Routes>
        {/* Public Routes */}
        <Route path="/giri-public-app-logs" element={<ApplicationLogsPublicPage />} />
        <Route path="/giri-public-user-logs" element={<ApplicationLogsPublicPage />} />
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/tournaments" element={<Tournaments />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/donate" element={<Donate />} />
        <Route path="/admin-login" element={<AdminLogin />} />
        <Route path="/user-login" element={<UserLogin />} />
        <Route path="/donor-login" element={<DonorLogin />} />
        <Route path="/student-login" element={<StudentLogin />} />
        <Route path="/session-timeout" element={<SessionTimeout />} />
        <Route path="/payment-status" element={<PaymentStatusPage />} />

        {/* App screens — default locked; optional open list in appScreenLockRegistry.js */}
        <Route path="/app" element={<AppShellLayout />}>
          <Route index element={<Navigate to="user-builder" replace />} />
          {APP_SCREEN_ROUTES.map(({ path, screenKey, element: Screen }) => (
            <Route
              key={path}
              path={path}
              element={
                <AppScreenAccessGuard screenKey={screenKey}>
                  <Screen />
                </AppScreenAccessGuard>
              }
            />
          ))}
          {VISITOR_LEGACY_ROUTES.map(({ path, screenKey, element: Screen }) => (
            <Route
              key={`legacy-${path}`}
              path={path}
              element={
                <AppScreenAccessGuard screenKey={screenKey}>
                  <Screen />
                </AppScreenAccessGuard>
              }
            />
          ))}
        </Route>

        {/* Role dashboards + legacy redirects */}
        {RoleShellRoutes()}

        {/* Any new role from User builder (e.g. /test/dashboard) */}
        {DynamicRoleShellRoutes()}
      </Routes>
    </Router>
  );
}

export default App;
